import { HTTP } from './helpers/http'

const DEFAULT_LIMIT = 25

export default {
  getAll(args = {}) {
    const { organizationId, limit = DEFAULT_LIMIT } = args
    if (!organizationId) return

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/notifications?limit=${limit}`
    )
  },

  getUnreadNotificationStatus({ organizationId, lastNotificationId }) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/notifications/unread/${lastNotificationId}`
    )
  },

  markAsRead({ organizationId, notificationIds }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/notifications/read`,
      {
        notificationIds,
      }
    )
  },
}
